import type { NumberReadings } from "./numbers.js";

/**
 * What each way of saying a number is called, and when it is the right one.
 *
 * The copy rather than the behaviour, kept apart for the same reason the
 * pinyin panel's copy is: this changes when the explanation could be clearer,
 * and that is not a change to how anything works. The difference is where it
 * ended up. The pinyin panel's words went to the page, in
 * `articles/data/pinyin_settings.yaml`, because the panel is the same on every
 * visit; these cannot follow, because which rows a number has depends on the
 * number. A decimal has no digit-by-digit reading and a number with no 1 in
 * it has no `yāo` one, so the copy has to be where the row is built.
 */
/** The rows, in the order they are shown, and what each is called. */
export const numberRows: readonly {
  readonly key: keyof NumberReadings;
  readonly label: string;
  readonly note: string;
}[] = [
  {
    key: "cardinal",
    label: "As a quantity",
    note: "Counting things: 2026 个, 2026 块钱.",
  },
  {
    key: "digits",
    label: "Digit by digit",
    note: "Years, and any number read out rather than counted: 2026 年.",
  },
  {
    key: "yao",
    label: "Digit by digit, with yāo",
    note: "Phone and room numbers, where 一 is said yāo so it is not heard as 七.",
  },
  {
    key: "percent",
    label: "As a percentage",
    note: "百分之 comes first: literally “of a hundred parts, this many”.",
  },
  {
    key: "financial",
    label: "As money, in financial numerals",
    note: "Cheques, receipts and contracts: characters that are harder to alter with a pen. 整 marks whole yuan.",
  },
];
